import { call } from 'redux-saga/effects';
import { addFlashMessage } from '../../../../utils/flashMessages.utils';
import { ISyncWrikeFoldersPayload, IWrikeFoldersParams } from './wrike.types';
import * as service from '../../../resource/wrike-folder/wrike-folder.saga-service';

export function* integrateWrike(code: string, state: string) {
  yield call(service.integrateWrike, code, state);
}

export function* fetchWrikeFolders(params?: IWrikeFoldersParams) {
  yield call(service.fetchWrikeFolders, params);
}

export function* syncWrikeFolders(payload: ISyncWrikeFoldersPayload) {
  yield call(service.syncWrikeFolders, payload);
  yield call(addFlashMessage, {
    type: 'success',
    message: 'Wrike folders have been successfully synced with meetings.',
  });
}

export function* removeWrikeIntegration() {
  yield call(service.removeWrikeIntegration);
  yield call(addFlashMessage, {
    type: 'success',
    message: 'Wrike integration has been removed successfully.',
  });
}
